import axios from "axios";
import React, { useEffect, useState } from "react";
import {
    Grid,
    Typography,
    TextField,
    FormControl,
    Button,
    Box,
    Card,
    CardContent,
    Dialog,DialogActions,DialogContent,DialogTitle,
    IconButton,
    MenuItem,
    Select,
    FormHelperText,
    DialogContentText,
    Divider
} from "@mui/material";
import { useForm } from "react-hook-form";
import PageContainer from "./Pagecontainer";
import { IconAlertTriangle, IconCheck, IconX } from "@tabler/icons-react";
import { BeatLoader } from "react-spinners";
import ScheduleDemo from "./demo";
import Cookies from 'js-cookie';
const CardDetails = () => {
    const { register, handleSubmit, setValue, trigger, formState: { errors },watch } = useForm();
    const [isEditing, setIsEditing] = useState(false); 
    const [subid, setsubid] = useState('')
    const [Errorpopup,setErrorpopup]= useState(false)
    const [errorMessage,seterrorMessage]= useState('')
    const [Loader,setLoader]=useState(true)
    const [successpopup,setSuccesspopup]= useState(false)
    const [successMessage,setsuccessMessage]= useState('')
    const Userinfo = JSON.parse(Cookies.get("user-info"));

    const getData = async () => {
        setLoader(true)
        try {
            const config2 = {
                headers: { Authorization: `gAAAAABmpzmxUPtDE5__xR3VyJ8zR-2y9NeVxnM6pGqfgdR2UuC6ehPsn1RoCGFIZlDhEIu7P67WVP8ktyfYtFFZB63B4wGNCQ==` }
              }
            const response = await axios.get(`${process.env.REACT_APP_API_URL2}/apiV1/get-card-details/?user_id=${Userinfo.id} `,config2);
            if (response.status === 200) {
                setValue("cardNumber", response.data.card_number);
                const maskedCardNumber = `XXXX ${response.data.card_number}`;
                setValue("cardNumberFormatted",maskedCardNumber)
                setValue("expiryDate", "");
                setValue("cvv", "");
                setsubid(response.data.subscription_id)
                setLoader(false)

            }
        } catch (err) {
            console.log(err);
            setLoader(false)
            
        }
    };
    
    useEffect(() => {
        getData();
    }, []);
    const onSubmit = async (data) => {
        setLoader(true)
        const sanitizeCard = (num) => num.replace(/\s+/g, '');
        try {
            let req = {
                sub_id: subid,
                // card_number: data.cardNumber,
                card_number: sanitizeCard(data.cardNumber),
                // expiry: data.expiryDate,
                expiry: `${data.expiryMonth}/${data.expiryYear}`,
                card_code: data.cvv
            }
            const response = await axios.post('/apiV1/update-card-details/', req)
            if (response.status == 200) {
                setLoader(false)
                setIsEditing(false);
                getData()
                setSuccesspopup(true)
                setsuccessMessage("Card details updated successfully")

            }
        } catch (err) {
            console.log(err);
            setErrorpopup(true)
            seterrorMessage(err.response.data.message)
            setLoader(false)
            setIsEditing(false)
            getData()

        }
    };

    return (
        <PageContainer title="SmartInvestorDeck | Card Details">
             <ScheduleDemo showBanner={true} />
            <Box sx={{ display: "flex", justifyContent: "center", mt: 4 }}>
                <Card sx={{ width: "100%", maxWidth: 500, padding: 3, boxShadow: 3 }}>
                    <CardContent>
                        <Typography variant="h6" sx={{ fontWeight: "bold", mb: 2 }}>
                            Card Details
                        </Typography>

                        <form onSubmit={isEditing ? handleSubmit(onSubmit) : (e) => e.preventDefault()}>
                            <Grid container spacing={2}>
                                <Grid item xs={12}>
                                    <FormControl fullWidth>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            Card Number <span style={{ color: "red", fontSize: "15px" }}>*</span>
                                        </Typography>
                                        <TextField
                                            placeholder="Card Number"
                                            value={watch("cardNumberFormatted") || ""}
                                            {...register("cardNumber", {
                                                required: "Card number is required",})}
                                            onChange={(e) => {
                                            const rawValue = e.target.value.replace(/\D/g, "").slice(0, 16); 
                                            const formattedValue = rawValue.replace(/(.{4})/g, "$1 ").trim(); 
                                            setValue("cardNumber", rawValue); 
                                            setValue("cardNumberFormatted", formattedValue); 
                                            trigger("cardNumber");
                                            }}
                                            error={!!errors.cardNumber}
                                            helperText={errors.cardNumber?.message}
                                            onKeyUp={() => trigger("cardNumber")}
                                            disabled={!isEditing || Loader}
                                        />
                                    </FormControl>
                                </Grid>
                                
                                <Grid item xs={12}>
                                <FormControl fullWidth sx={{ mb: 2 }}>
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    Expiry Date <span style={{ color: "red", fontSize: "15px" }}>*</span>
                                </Typography>

                                <Grid container spacing={2}>
                                <Grid item xs={6}>
                                    <Select
                                        fullWidth
                                        value={watch("expiryYear") || ""}
                                        {...register("expiryYear", {
                                        required: "Year is required",
                                        })}
                                        onChange={(e) => {setValue("expiryYear", e.target.value);trigger("expiryYear")}}
                                        displayEmpty
                                        disabled={!isEditing || Loader}
                                        sx={{
                                            maxHeight: "40px",
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 450, 
                                                    overflowY: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                        Year
                                        </MenuItem>
                                        {Array.from({ length: 10 }, (_, i) => {
                                        const year = new Date().getFullYear() + i;
                                        return (
                                            <MenuItem key={year} value={year}>
                                            {year}
                                            </MenuItem>
                                        );
                                        })}
                                    </Select>
                                    {errors.expiryYear && (
                                        <FormHelperText error>{errors.expiryYear.message}</FormHelperText>
                                    )}
                                    </Grid>
                                    <Grid item xs={6}>
                                    <Select
                                        fullWidth
                                        value={watch("expiryMonth") || ""}
                                        {...register("expiryMonth", {
                                        required: "Month is required",
                                        validate: (value) => {
                                            const selectedYear = parseInt(watch("expiryYear"));
                                            const currentYear = new Date().getFullYear();
                                            const currentMonth = new Date().getMonth() + 1; 
                                            const selectedMonth = parseInt(value);
                                        
                                            if (
                                              selectedYear === currentYear &&
                                              selectedMonth <= currentMonth - 1
                                            ) {
                                              return "Please select a future month";
                                            }
                                        
                                            return true;
                                          },
                                        })}
                                        onChange={(e) => {setValue("expiryMonth", e.target.value);trigger("expiryMonth")}}
                                        displayEmpty
                                        disabled={!isEditing || Loader}
                                        sx={{
                                            maxHeight: "40px",
                                        }}
                                        MenuProps={{
                                            PaperProps: {
                                                style: {
                                                    maxHeight: 450, 
                                                    overflowY: "auto",
                                                },
                                            },
                                        }}
                                    >
                                        <MenuItem value="" disabled>
                                        Month
                                        </MenuItem>
                                        {Array.from({ length: 12 }, (_, i) => (
                                        <MenuItem key={i + 1} value={(i + 1).toString().padStart(2, "0")}>
                                            {(i + 1).toString().padStart(2, "0")}
                                        </MenuItem>
                                        ))}
                                    </Select>
                                    {errors.expiryMonth && (
                                        <FormHelperText error>{errors.expiryMonth.message}</FormHelperText>
                                    )}
                                    </Grid>

                                   
                                </Grid>
                                </FormControl>
                                </Grid>

                                <Grid item xs={6}>
                                    <FormControl fullWidth>
                                        <Typography variant="body2" sx={{ mb: 1 }}>
                                            CVV <span style={{ color: "red", fontSize: "15px" }}>*</span>
                                        </Typography>
                                        <TextField
                                            placeholder="XXXX"
                                            {...register("cvv", {
                                                required: "CVV is required",
                                                pattern: {
                                                    value: /^[0-9]{3,4}$/,
                                                    message: "CVV must be 3 or 4 digits"
                                                }
                                            })}
                                            error={!!errors.cvv}
                                            helperText={errors.cvv?.message}
                                            onKeyUp={() => trigger("cvv")}
                                            disabled={!isEditing || Loader}
                                            inputProps={{ maxLength: 4 }}

                                        />
                                    </FormControl>
                                </Grid>
                            </Grid>
                            {isEditing ?
                                <Button type="submit" variant="contained" className="button2" sx={{ mt: 2 }} disabled={Loader}>
                                    {Loader ? <BeatLoader color="#fff"/>:"Save"}
                                </Button> : ""}
                        </form>
                        {!isEditing ? <Button
                            variant="outlined"
                            color="primary"
                            onClick={() => setIsEditing(true)}
                            sx={{ mt: 2 }}
                            disabled={Loader}
                            >
                            Edit
                        </Button> : ""}
                    </CardContent>
                </Card>
            </Box>
            <Dialog
                        open={Errorpopup}
                        onClose={()=>setErrorpopup(false)}
                        aria-labelledby="error-dialog-title"
                        aria-describedby="error-dialog-description"
                        PaperProps={{
                            sx: { borderRadius: "16px", padding: "16px" },
                        }}
                        fullWidth
                        maxWidth="sm"
                        >
                {/* Close Button */}
                <Box display="flex" justifyContent="space-between" alignItems="center">
                    <Box />
                    <IconButton size="small" onClick={()=>setErrorpopup(false)}>
                    <IconX />
                    </IconButton>
                </Box>

                {/* Error Icon & Title */}
                <DialogTitle id="error-dialog-title" align="center" sx={{ marginTop: -3 }}>
                    <Box display="flex" justifyContent="center" alignItems="center">
                    <Box
                        sx={{
                        width: 60,
                        height: 60,
                        backgroundColor: "#fff3cd",
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        borderRadius: "50%",
                        marginBottom: 2,
                        }}
                    >
                        <IconAlertTriangle size={32} color="#ff9800" />
                    </Box>
                    </Box>
                    <Typography variant="h6" fontWeight="bold">
                    Error 
                    </Typography>
                </DialogTitle>

                {/* Error Message */}
                <DialogContent>
                    <Typography id="error-dialog-description" align="center">
                    {errorMessage || "An unexpected error has occurred. Please try again."}
                    </Typography>
                </DialogContent>

                {/* Close Button */}
                <DialogActions sx={{ display: "flex", justifyContent: "center", gap: 2, marginBottom: 1 }}>
                    <Button
                    variant="contained"
                    color="error"
                    sx={{ backgroundColor: "#c63037", border: "none" }}
                    onClick={()=>setErrorpopup(false)}
                    >
                    Close
                    </Button>
                </DialogActions>
                </Dialog>
                <Dialog  open={successpopup}  fullWidth  maxWidth="xs" sx={{ textAlign: "center" }}>
            <DialogTitle id="alert-dialog-title" sx={{ fontWeight: "bold" }}>
                Success
            </DialogTitle>

            <Divider />

            <DialogContent>
                <Box sx={{ display: "flex", justifyContent: "center", mb: 2 }}>
                <IconButton
                    disableRipple
                    sx={{
                  backgroundColor: "#e6f4ea",
                  padding: 3,
                  "&:hover": { backgroundColor: "#c3e6cb" }
                }}
              >
                <IconCheck color="#28a745" size={50} />
              </IconButton>
            </Box>

            <DialogContentText id="alert-dialog-description" sx={{ textAlign: "center", fontSize: "16px", color: "#333" }}>
              {successMessage}
            </DialogContentText>
          </DialogContent>

          <Divider />

          <DialogActions>
            <Button
              onClick={() => { { setSuccesspopup(false) } }}
              sx={{
                olor: "#fff",
                fontSize: "16px",
                fontWeight: "bold",
                borderRadius: "8px",
              }}
              className="button2"
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        </PageContainer>
    );
};

export default CardDetails;
